import React from 'react';
import InternalContainer from '../../layout/containers/Internal';
import UserList from '../components/UserList/UserList';

const UserListContainer = ({
  location: {
    query: { status },
  },
}) => {
  return (
    <InternalContainer title="Admin / Users">
      <UserList status={status} />
    </InternalContainer>
  );
};

export default UserListContainer;
